'use strict';

var isInteger = require('math-intrinsics/isInteger');

// https://262.ecma-international.org/6.0/#sec-isinteger

module.exports = function IsInteger(argument) {
	return isInteger(argument);
};
